"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashedMap = void 0;
const Hashing_1 = require("./Hashing");
const HashedObject_1 = require("./HashedObject");
class HashedMap {
    constructor(init) {
        this.content = new Map();
        this.contentHashes = new Map();
        if (init !== undefined) {
            for (const [key, value] of init) {
                this.set(key, value);
            }
        }
    }
    set(key, value) {
        let hash = HashedObject_1.HashedObject.hashElement(value);
        this.content.set(key, value);
        this.contentHashes.set(key, hash);
    }
    remove(key) {
        this.content.delete(key);
        this.contentHashes.delete(key);
    }
    has(key) {
        return this.contentHashes.has(key);
    }
    entries() {
        return this.content.entries();
    }
    toArrays() {
        let keys = Array.from(this.content.keys());
        keys.sort();
        let entries = [];
        let hashes = [];
        for (const key of keys) {
            entries.push([key, this.content.get(key)]);
            hashes.push(this.contentHashes.get(key));
        }
        return { entries: entries, hashes: hashes };
    }
    fromArrays(_hashes, entries) {
        for (let i = 0; i < entries.length; i++) {
            let [key, value] = entries[i];
            this.set(key, value);
        }
    }
    equals(another) {
        let thisArrays = this.toArrays();
        let anotherArrays = another.toArrays();
        let result = thisArrays.entries.length == anotherArrays.entries.length;
        for (let i = 0; result && i < thisArrays.entries.length; i++) {
            const thisKey = thisArrays.entries[i][0];
            const anotherKey = anotherArrays.entries[i][0];
            const thisHash = thisArrays.hashes[i];
            const anotherHash = anotherArrays.hashes[i];
            result = result &&
                thisKey === anotherKey &&
                thisHash === anotherHash;
        }
        return result;
    }
    literalize(path = '', context) {
        let dependencies = new Set();
        let arrays = this.toArrays();
        let hashes = arrays.hashes;
        let child = HashedObject_1.HashedObject.literalizeField(path, arrays.entries, context);
        let entries = child.value;
        HashedObject_1.HashedObject.collectChildDeps(dependencies, child.dependencies);
        let value = { _type: 'hashed_map', _hashes: hashes, _entries: entries };
        return { value: value, dependencies: dependencies };
    }
    hash() {
        return Hashing_1.Hashing.forValue(this.literalize().value);
    }
    static deliteralize(value, context, validate = false) {
        if (value['_type'] !== 'hashed_map') {
            throw new Error("Trying to deliteralize value, but _type is '" + value['_type'] + "' (shoud be 'hashed_map')");
        }
        let hashes = value['_hashes'];
        let entries = HashedObject_1.HashedObject.deliteralizeField(value['_entries'], context, validate);
        let hmap = new HashedMap();
        hmap.fromArrays(hashes, entries);
        return hmap;
    }
}
exports.HashedMap = HashedMap;
//# sourceMappingURL=HashedMap.js.map